import React from "react";

const ResetIcon = () => {
  return (
    <svg
      viewBox="0 0 22 24"
      className="h-6 w-6"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19 6a11 11 0 0 0-4.8-3.2l6-1.2a.24.24 0 0 0 .19-.29l-.22-1a.24.24 0 0 0-.29-.19l-8.6 1.8a.24.24 0 0 0-.18.3l2.4 8.5a.24.24 0 0 0 .3.17l1-.29a.24.24 0 0 0 .17-.3l-1.7-6.1a9.4 9.4 0 0 1 6.8 9c0 5.2-4.2 9.4-9.4 9.4s-9.4-4.2-9.4-9.4a9.3 9.3 0 0 1 2.2-6.1.24.24 0 0 0-.023-.34l-.8-.71a.24.24 0 0 0-.35.023 11 11 0 1 0 17 0z" />
    </svg>
  );
};

export default ResetIcon;
